import { render, staticRenderFns } from "./PythonView.vue?vue&type=template&id=648e966e&scoped=true&"
import script from "./PythonView.vue?vue&type=script&lang=js&"
export * from "./PythonView.vue?vue&type=script&lang=js&"
import style0 from "./PythonView.vue?vue&type=style&index=0&id=648e966e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e966e",
  null
  
)

export default component.exports